import * as React from "react";
import { ResponsivePie, PieSvgProps } from "@nivo/pie";
import { BasicTooltip } from "@nivo/tooltip";

export interface DonutChartData {
    id: string;
    label: string;
    value: number;
    color: string;
}

interface DonutChartProps extends Pick<PieSvgProps<any>, "fill" | "tooltip" | "data" | "animate" | "defs" | "borderColor" | "borderWidth" | "margin" | "id" | "role" | "onClick" | "onMouseEnter" | "onMouseLeave" | "onMouseMove" | "value" | "legends" | "startAngle" | "endAngle" | "innerRadius" | "theme" | "arcLabelsRadiusOffset" | "arcLabelsSkipAngle" | "arcLabelsTextColor" | "arcLabelsComponent" | "transitionMode" | "component" | "arcLinkLabel" | "arcLinkLabelsSkipAngle" | "arcLinkLabelsOffset" | "arcLinkLabelsDiagonalLength" | "arcLinkLabelsStraightLength" | "arcLinkLabelsThickness" | "arcLinkLabelsTextOffset" | "arcLinkLabelsTextColor" | "arcLinkLabelsColor" | "cornerRadius" | "padAngle" | "valueFormat" | "arcLabel" | "motionConfig" | "isInteractive" | "colors" | "sortByValue" | "fit" | "activeInnerRadiusOffset" | "activeOuterRadiusOffset" | "enableArcLabels" | "enableArcLinkLabels" | "renderWrapper" | "layers" | "arcLinkLabelComponent"> {
}

export const DonutChart = ({ data, ...rest }: DonutChartProps) => {
    return (
        <ResponsivePie
            {...rest}
            data={data}
            margin={{ top: 40, right: 80, bottom: 80, left: 80 }}
            startAngle={-3}
            innerRadius={0.5}
            cornerRadius={3}
            activeInnerRadiusOffset={16}
            activeOuterRadiusOffset={1}
            borderWidth={1}
            colors={{ datum: 'data.color' }}
            borderColor={{
                from: 'color',
                modifiers: [
                    [
                        'darker',
                        0.2
                    ]
                ]
            }}
            arcLinkLabel="label"
            arcLinkLabelsSkipAngle={5}
            arcLinkLabelsTextColor="#333333"
            arcLinkLabelsThickness={2}
            arcLinkLabelsColor={{ from: 'color' }}
            arcLabelsSkipAngle={5}
            arcLabelsTextColor={{
                from: 'color',
                modifiers: [
                    [
                        'darker',
                        2
                    ]
                ]
            }}
            tooltip={(id) => <BasicTooltip id={id.datum.label} value={id.datum.value} />}
        />
    );
}
